var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInCallMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.666V14.666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66602V7.99935C12.6667 9.23703 12.175 10.424 11.2999 11.2992C10.4247 12.1744 9.23772 12.666 8.00004 12.666C6.76236 12.666 5.57538 12.1744 4.70021 11.2992C3.82504 10.424 3.33337 9.23703 3.33337 7.99935V6.66602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33398C10 2.22941 9.10457 1.33398 8 1.33398C6.89543 1.33398 6 2.22941 6 3.33398V8.00065C6 9.10522 6.89543 10.0006 8 10.0006C9.10457 10.0006 10 9.10522 10 8.00065V3.33398Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCallMicOn);
export default __webpack_public_path__ + "static/media/in_call_mic_on.1c47308bd51f8da66d38bc147e565f69.svg";
export { ForwardRef as ReactComponent };